module.exports = __webpack_public_path__ + "img/Loading_r_48.619d96dd.png";